/**
 * Exempt Private Company Certificate (Section 260 & 261) — M32016
 * Certificate + Statement by Auditors. 필드 키는 Word 템플릿 [[변수]] 와 일치.
 */
export type EpcFieldType = 'text' | 'date' | 'entity' | 'person' | 'address';

export const EPC_KEYS = [
  'company_name',
  'company_registration_no',
  'fs_made_up_to',
  'circulation_date',
  'certification_date',
  'director_name',
  'secretary_name',
  'secretary_license_no',
  'secretary_practicing_cert_no',
  'audit_firm_name',
  'audit_firm_number',
  'auditor_name',
  'audit_license_no',
  'declaration_date',
  'statement_date',
  'lodger_name',
  'lodger_nric',
  'lodger_address',
  'lodger_phone',
  'lodger_email',
] as const;

export type EpcFieldKey = (typeof EPC_KEYS)[number];

const LABELS: Record<string, string> = {
  company_name: 'Company Name',
  company_registration_no: 'Registration No.',
  fs_made_up_to: 'FS Made Up To',
  circulation_date: 'Circulation Date',
  certification_date: 'Certification Date',
  director_name: 'Director Name',
  secretary_name: 'Secretary Name',
  secretary_license_no: 'License / Membership No.',
  secretary_practicing_cert_no: 'Practicing Certificate No.',
  audit_firm_name: 'Audit Firm Name',
  audit_firm_number: 'Audit Firm Number',
  auditor_name: 'Auditor Name',
  audit_license_no: 'Audit License No.',
  declaration_date: 'Declaration Date',
  statement_date: 'Statement Date',
  lodger_name: 'Lodger Name',
  lodger_nric: 'Lodger NRIC No.',
  lodger_address: 'Lodger Address',
  lodger_phone: 'Lodger Phone',
  lodger_email: 'Lodger Email',
};

export function labelize(key: string): string {
  return LABELS[key] || key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function typeOf(key: string): EpcFieldType {
  if (/_date$|_made_up_to$/.test(key)) return 'date';
  if (/_address$/.test(key)) return 'address';
  if (key === 'company_name') return 'entity';
  // audit_firm_name = 감사회사(AUDITOR ✦), auditor_name = 파트너(수동 입력)
  if (
    key === 'director_name'
    || key === 'secretary_name'
    || key === 'audit_firm_name'
    || key === 'lodger_name'
  ) return 'person';
  return 'text';
}

export function isOptional(key: string): boolean {
  return [
    'secretary_license_no',
    'secretary_practicing_cert_no',
    'lodger_phone',
    'lodger_email',
  ].includes(key);
}

export const EPC_REQUIRED = EPC_KEYS.filter((k) => !isOptional(k));
